let project_id = 0
let isLogin = false

export default {project_id, isLogin}